// source: io/codedrills/proto/judge/judge_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var io_codedrills_proto_judge_judge_pb = require('../../../../io/codedrills/proto/judge/judge_pb.js');
goog.object.extend(proto, io_codedrills_proto_judge_judge_pb);
var io_codedrills_proto_content_content_pb = require('../../../../io/codedrills/proto/content/content_pb.js');
goog.object.extend(proto, io_codedrills_proto_content_content_pb);
var io_codedrills_proto_content_preview_pb = require('../../../../io/codedrills/proto/content/preview_pb.js');
goog.object.extend(proto, io_codedrills_proto_content_preview_pb);
var io_codedrills_proto_content_pagination_pb = require('../../../../io/codedrills/proto/content/pagination_pb.js');
goog.object.extend(proto, io_codedrills_proto_content_pagination_pb);
var io_codedrills_proto_user_candidate_pb = require('../../../../io/codedrills/proto/user/candidate_pb.js');
goog.object.extend(proto, io_codedrills_proto_user_candidate_pb);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.AllSubmissionsRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.AllSubmissionsResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.CreateSolutionTemplateResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.DeleteAnswersRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.DeleteAnswersResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.FetchAnswerRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.FetchAnswerResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.FetchRejudgeRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.FetchRejudgeResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.ProblemStatus', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.RejudgeRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.RejudgeResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.ServerTimeRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.ServerTimeResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.SubmissionRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.SubmissionResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.SubmissionStatsRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.SubmissionStatsResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.SubmissionStatus', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.SubmissionStatusRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.SubmissionStatusResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.SubmitAnswerRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.SubmitAnswerResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.SubmitCodeRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.SubmitCodeResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.UploadContestSubmissionsRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.UploadContestSubmissionsResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.UserAttemptedProblemsRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.judge.master.UserAttemptedProblemsResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.SubmitCodeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.SubmitCodeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.SubmitCodeRequest.displayName = 'proto.io.codedrills.proto.judge.master.SubmitCodeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.SubmitCodeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.SubmitCodeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.SubmitCodeResponse.displayName = 'proto.io.codedrills.proto.judge.master.SubmitCodeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.SubmitAnswerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.SubmitAnswerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.SubmitAnswerRequest.displayName = 'proto.io.codedrills.proto.judge.master.SubmitAnswerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.SubmitAnswerResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.SubmitAnswerResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.SubmitAnswerResponse.displayName = 'proto.io.codedrills.proto.judge.master.SubmitAnswerResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.FetchAnswerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.FetchAnswerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.FetchAnswerRequest.displayName = 'proto.io.codedrills.proto.judge.master.FetchAnswerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.FetchAnswerResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.FetchAnswerResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.FetchAnswerResponse.displayName = 'proto.io.codedrills.proto.judge.master.FetchAnswerResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest.displayName = 'proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.CreateSolutionTemplateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.CreateSolutionTemplateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.CreateSolutionTemplateResponse.displayName = 'proto.io.codedrills.proto.judge.master.CreateSolutionTemplateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.SubmissionStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.SubmissionStatusRequest.displayName = 'proto.io.codedrills.proto.judge.master.SubmissionStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.SubmissionStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.displayName = 'proto.io.codedrills.proto.judge.master.SubmissionStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.SubmissionStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.SubmissionStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.SubmissionStatus.displayName = 'proto.io.codedrills.proto.judge.master.SubmissionStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest.displayName = 'proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse.displayName = 'proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest.displayName = 'proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse.displayName = 'proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.UserAttemptedProblemsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.UserAttemptedProblemsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.UserAttemptedProblemsRequest.displayName = 'proto.io.codedrills.proto.judge.master.UserAttemptedProblemsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.UserAttemptedProblemsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.UserAttemptedProblemsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.UserAttemptedProblemsResponse.displayName = 'proto.io.codedrills.proto.judge.master.UserAttemptedProblemsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.ProblemStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.ProblemStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.ProblemStatus.displayName = 'proto.io.codedrills.proto.judge.master.ProblemStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.SubmissionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.SubmissionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.SubmissionRequest.displayName = 'proto.io.codedrills.proto.judge.master.SubmissionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.SubmissionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.judge.master.SubmissionResponse.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.SubmissionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.SubmissionResponse.displayName = 'proto.io.codedrills.proto.judge.master.SubmissionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.SubmissionStatsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.SubmissionStatsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.SubmissionStatsRequest.displayName = 'proto.io.codedrills.proto.judge.master.SubmissionStatsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.SubmissionStatsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.SubmissionStatsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.SubmissionStatsResponse.displayName = 'proto.io.codedrills.proto.judge.master.SubmissionStatsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryRequest.displayName = 'proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse.displayName = 'proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.ServerTimeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.ServerTimeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.ServerTimeRequest.displayName = 'proto.io.codedrills.proto.judge.master.ServerTimeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.ServerTimeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.ServerTimeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.ServerTimeResponse.displayName = 'proto.io.codedrills.proto.judge.master.ServerTimeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.RejudgeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.judge.master.RejudgeRequest.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.RejudgeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.RejudgeRequest.displayName = 'proto.io.codedrills.proto.judge.master.RejudgeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.RejudgeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.RejudgeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.RejudgeResponse.displayName = 'proto.io.codedrills.proto.judge.master.RejudgeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.FetchRejudgeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.FetchRejudgeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.FetchRejudgeRequest.displayName = 'proto.io.codedrills.proto.judge.master.FetchRejudgeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.FetchRejudgeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.judge.master.FetchRejudgeResponse.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.FetchRejudgeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.FetchRejudgeResponse.displayName = 'proto.io.codedrills.proto.judge.master.FetchRejudgeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest.displayName = 'proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse.displayName = 'proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.UploadContestSubmissionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.UploadContestSubmissionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.UploadContestSubmissionsRequest.displayName = 'proto.io.codedrills.proto.judge.master.UploadContestSubmissionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.UploadContestSubmissionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.UploadContestSubmissionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.UploadContestSubmissionsResponse.displayName = 'proto.io.codedrills.proto.judge.master.UploadContestSubmissionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest.displayName = 'proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse.displayName = 'proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest.displayName = 'proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse.displayName = 'proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.DeleteAnswersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.judge.master.DeleteAnswersRequest.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.DeleteAnswersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.DeleteAnswersRequest.displayName = 'proto.io.codedrills.proto.judge.master.DeleteAnswersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.DeleteAnswersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.DeleteAnswersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.DeleteAnswersResponse.displayName = 'proto.io.codedrills.proto.judge.master.DeleteAnswersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.AllSubmissionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.AllSubmissionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.AllSubmissionsRequest.displayName = 'proto.io.codedrills.proto.judge.master.AllSubmissionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.judge.master.AllSubmissionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.judge.master.AllSubmissionsResponse.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.judge.master.AllSubmissionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.judge.master.AllSubmissionsResponse.displayName = 'proto.io.codedrills.proto.judge.master.AllSubmissionsResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.SubmitCodeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.SubmitCodeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.SubmitCodeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.SubmitCodeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    problemId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    version: jspb.Message.getFieldWithDefault(msg, 2, 0),
    language: jspb.Message.getFieldWithDefault(msg, 3, 0),
    code: jspb.Message.getFieldWithDefault(msg, 4, ""),
    userStdinInput: jspb.Message.getFieldWithDefault(msg, 5, ""),
    submissionType: jspb.Message.getFieldWithDefault(msg, 7, 0),
    parentId: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.SubmitCodeRequest}
 */
proto.io.codedrills.proto.judge.master.SubmitCodeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.SubmitCodeRequest;
  return proto.io.codedrills.proto.judge.master.SubmitCodeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.SubmitCodeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.SubmitCodeRequest}
 */
proto.io.codedrills.proto.judge.master.SubmitCodeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProblemId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    case 3:
      var value = /** @type {!proto.io.codedrills.proto.judge.Language} */ (reader.readEnum());
      msg.setLanguage(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserStdinInput(value);
      break;
    case 7:
      var value = /** @type {!proto.io.codedrills.proto.judge.SubmissionType} */ (reader.readEnum());
      msg.setSubmissionType(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setParentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.SubmitCodeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.SubmitCodeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.SubmitCodeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.SubmitCodeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProblemId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getLanguage();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUserStdinInput();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSubmissionType();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getParentId();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
};


/**
 * optional int32 problem_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.SubmitCodeRequest.prototype.getProblemId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmitCodeRequest} returns this
 */
proto.io.codedrills.proto.judge.master.SubmitCodeRequest.prototype.setProblemId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 version = 2;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.SubmitCodeRequest.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmitCodeRequest} returns this
 */
proto.io.codedrills.proto.judge.master.SubmitCodeRequest.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional io.codedrills.proto.judge.Language language = 3;
 * @return {!proto.io.codedrills.proto.judge.Language}
 */
proto.io.codedrills.proto.judge.master.SubmitCodeRequest.prototype.getLanguage = function() {
  return /** @type {!proto.io.codedrills.proto.judge.Language} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.io.codedrills.proto.judge.Language} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmitCodeRequest} returns this
 */
proto.io.codedrills.proto.judge.master.SubmitCodeRequest.prototype.setLanguage = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string code = 4;
 * @return {string}
 */
proto.io.codedrills.proto.judge.master.SubmitCodeRequest.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmitCodeRequest} returns this
 */
proto.io.codedrills.proto.judge.master.SubmitCodeRequest.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string user_stdin_input = 5;
 * @return {string}
 */
proto.io.codedrills.proto.judge.master.SubmitCodeRequest.prototype.getUserStdinInput = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmitCodeRequest} returns this
 */
proto.io.codedrills.proto.judge.master.SubmitCodeRequest.prototype.setUserStdinInput = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional io.codedrills.proto.judge.SubmissionType submission_type = 7;
 * @return {!proto.io.codedrills.proto.judge.SubmissionType}
 */
proto.io.codedrills.proto.judge.master.SubmitCodeRequest.prototype.getSubmissionType = function() {
  return /** @type {!proto.io.codedrills.proto.judge.SubmissionType} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.io.codedrills.proto.judge.SubmissionType} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmitCodeRequest} returns this
 */
proto.io.codedrills.proto.judge.master.SubmitCodeRequest.prototype.setSubmissionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional int32 parent_id = 8;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.SubmitCodeRequest.prototype.getParentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmitCodeRequest} returns this
 */
proto.io.codedrills.proto.judge.master.SubmitCodeRequest.prototype.setParentId = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.SubmitCodeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.SubmitCodeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.SubmitCodeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.SubmitCodeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    submissionId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.SubmitCodeResponse}
 */
proto.io.codedrills.proto.judge.master.SubmitCodeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.SubmitCodeResponse;
  return proto.io.codedrills.proto.judge.master.SubmitCodeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.SubmitCodeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.SubmitCodeResponse}
 */
proto.io.codedrills.proto.judge.master.SubmitCodeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setSubmissionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.SubmitCodeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.SubmitCodeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.SubmitCodeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.SubmitCodeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubmissionId();
  if (f !== 0) {
    writer.writeFixed32(
      1,
      f
    );
  }
};


/**
 * optional fixed32 submission_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.SubmitCodeResponse.prototype.getSubmissionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmitCodeResponse} returns this
 */
proto.io.codedrills.proto.judge.master.SubmitCodeResponse.prototype.setSubmissionId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.SubmitAnswerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.SubmitAnswerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.SubmitAnswerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.SubmitAnswerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    answer: (f = msg.getAnswer()) && io_codedrills_proto_user_candidate_pb.Answer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.SubmitAnswerRequest}
 */
proto.io.codedrills.proto.judge.master.SubmitAnswerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.SubmitAnswerRequest;
  return proto.io.codedrills.proto.judge.master.SubmitAnswerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.SubmitAnswerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.SubmitAnswerRequest}
 */
proto.io.codedrills.proto.judge.master.SubmitAnswerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_user_candidate_pb.Answer;
      reader.readMessage(value,io_codedrills_proto_user_candidate_pb.Answer.deserializeBinaryFromReader);
      msg.setAnswer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.SubmitAnswerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.SubmitAnswerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.SubmitAnswerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.SubmitAnswerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAnswer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_user_candidate_pb.Answer.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.user.Answer answer = 1;
 * @return {?proto.io.codedrills.proto.user.Answer}
 */
proto.io.codedrills.proto.judge.master.SubmitAnswerRequest.prototype.getAnswer = function() {
  return /** @type{?proto.io.codedrills.proto.user.Answer} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_user_candidate_pb.Answer, 1));
};


/**
 * @param {?proto.io.codedrills.proto.user.Answer|undefined} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmitAnswerRequest} returns this
*/
proto.io.codedrills.proto.judge.master.SubmitAnswerRequest.prototype.setAnswer = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.master.SubmitAnswerRequest} returns this
 */
proto.io.codedrills.proto.judge.master.SubmitAnswerRequest.prototype.clearAnswer = function() {
  return this.setAnswer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.master.SubmitAnswerRequest.prototype.hasAnswer = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.SubmitAnswerResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.SubmitAnswerResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.SubmitAnswerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.SubmitAnswerResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.SubmitAnswerResponse}
 */
proto.io.codedrills.proto.judge.master.SubmitAnswerResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.SubmitAnswerResponse;
  return proto.io.codedrills.proto.judge.master.SubmitAnswerResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.SubmitAnswerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.SubmitAnswerResponse}
 */
proto.io.codedrills.proto.judge.master.SubmitAnswerResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.SubmitAnswerResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.SubmitAnswerResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.SubmitAnswerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.SubmitAnswerResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.FetchAnswerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.FetchAnswerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.FetchAnswerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.FetchAnswerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    parentId: (f = msg.getParentId()) && io_codedrills_proto_content_content_pb.ContentId.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.FetchAnswerRequest}
 */
proto.io.codedrills.proto.judge.master.FetchAnswerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.FetchAnswerRequest;
  return proto.io.codedrills.proto.judge.master.FetchAnswerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.FetchAnswerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.FetchAnswerRequest}
 */
proto.io.codedrills.proto.judge.master.FetchAnswerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuestionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = new io_codedrills_proto_content_content_pb.ContentId;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.ContentId.deserializeBinaryFromReader);
      msg.setParentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.FetchAnswerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.FetchAnswerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.FetchAnswerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.FetchAnswerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getParentId();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      io_codedrills_proto_content_content_pb.ContentId.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 question_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.FetchAnswerRequest.prototype.getQuestionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.FetchAnswerRequest} returns this
 */
proto.io.codedrills.proto.judge.master.FetchAnswerRequest.prototype.setQuestionId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.io.codedrills.proto.judge.master.FetchAnswerRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.master.FetchAnswerRequest} returns this
 */
proto.io.codedrills.proto.judge.master.FetchAnswerRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional io.codedrills.proto.content.ContentId parent_id = 3;
 * @return {?proto.io.codedrills.proto.content.ContentId}
 */
proto.io.codedrills.proto.judge.master.FetchAnswerRequest.prototype.getParentId = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentId} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.ContentId, 3));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentId|undefined} value
 * @return {!proto.io.codedrills.proto.judge.master.FetchAnswerRequest} returns this
*/
proto.io.codedrills.proto.judge.master.FetchAnswerRequest.prototype.setParentId = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.master.FetchAnswerRequest} returns this
 */
proto.io.codedrills.proto.judge.master.FetchAnswerRequest.prototype.clearParentId = function() {
  return this.setParentId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.master.FetchAnswerRequest.prototype.hasParentId = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.FetchAnswerResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.FetchAnswerResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.FetchAnswerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.FetchAnswerResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    answer: (f = msg.getAnswer()) && io_codedrills_proto_user_candidate_pb.Answer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.FetchAnswerResponse}
 */
proto.io.codedrills.proto.judge.master.FetchAnswerResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.FetchAnswerResponse;
  return proto.io.codedrills.proto.judge.master.FetchAnswerResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.FetchAnswerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.FetchAnswerResponse}
 */
proto.io.codedrills.proto.judge.master.FetchAnswerResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_user_candidate_pb.Answer;
      reader.readMessage(value,io_codedrills_proto_user_candidate_pb.Answer.deserializeBinaryFromReader);
      msg.setAnswer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.FetchAnswerResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.FetchAnswerResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.FetchAnswerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.FetchAnswerResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAnswer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_user_candidate_pb.Answer.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.user.Answer answer = 1;
 * @return {?proto.io.codedrills.proto.user.Answer}
 */
proto.io.codedrills.proto.judge.master.FetchAnswerResponse.prototype.getAnswer = function() {
  return /** @type{?proto.io.codedrills.proto.user.Answer} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_user_candidate_pb.Answer, 1));
};


/**
 * @param {?proto.io.codedrills.proto.user.Answer|undefined} value
 * @return {!proto.io.codedrills.proto.judge.master.FetchAnswerResponse} returns this
*/
proto.io.codedrills.proto.judge.master.FetchAnswerResponse.prototype.setAnswer = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.master.FetchAnswerResponse} returns this
 */
proto.io.codedrills.proto.judge.master.FetchAnswerResponse.prototype.clearAnswer = function() {
  return this.setAnswer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.master.FetchAnswerResponse.prototype.hasAnswer = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    problemId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    version: jspb.Message.getFieldWithDefault(msg, 2, 0),
    language: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest}
 */
proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest;
  return proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest}
 */
proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProblemId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    case 3:
      var value = /** @type {!proto.io.codedrills.proto.judge.Language} */ (reader.readEnum());
      msg.setLanguage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProblemId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getLanguage();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional int32 problem_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest.prototype.getProblemId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest} returns this
 */
proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest.prototype.setProblemId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 version = 2;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest} returns this
 */
proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional io.codedrills.proto.judge.Language language = 3;
 * @return {!proto.io.codedrills.proto.judge.Language}
 */
proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest.prototype.getLanguage = function() {
  return /** @type {!proto.io.codedrills.proto.judge.Language} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.io.codedrills.proto.judge.Language} value
 * @return {!proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest} returns this
 */
proto.io.codedrills.proto.judge.master.CreateSolutionTemplateRequest.prototype.setLanguage = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.CreateSolutionTemplateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.CreateSolutionTemplateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.CreateSolutionTemplateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.CreateSolutionTemplateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.CreateSolutionTemplateResponse}
 */
proto.io.codedrills.proto.judge.master.CreateSolutionTemplateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.CreateSolutionTemplateResponse;
  return proto.io.codedrills.proto.judge.master.CreateSolutionTemplateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.CreateSolutionTemplateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.CreateSolutionTemplateResponse}
 */
proto.io.codedrills.proto.judge.master.CreateSolutionTemplateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.CreateSolutionTemplateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.CreateSolutionTemplateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.CreateSolutionTemplateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.CreateSolutionTemplateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.io.codedrills.proto.judge.master.CreateSolutionTemplateResponse.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.master.CreateSolutionTemplateResponse} returns this
 */
proto.io.codedrills.proto.judge.master.CreateSolutionTemplateResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.SubmissionStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    submissionId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatusRequest}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.SubmissionStatusRequest;
  return proto.io.codedrills.proto.judge.master.SubmissionStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatusRequest}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setSubmissionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.SubmissionStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubmissionId();
  if (f !== 0) {
    writer.writeFixed32(
      1,
      f
    );
  }
};


/**
 * optional fixed32 submission_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusRequest.prototype.getSubmissionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatusRequest} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusRequest.prototype.setSubmissionId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    submissionId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0),
    result: jspb.Message.getFieldWithDefault(msg, 3, ""),
    timeTaken: jspb.Message.getFieldWithDefault(msg, 4, 0),
    memoryTaken: jspb.Message.getFieldWithDefault(msg, 5, 0),
    submissionType: jspb.Message.getFieldWithDefault(msg, 6, 0),
    sampleResultViewsList: jspb.Message.toObjectList(msg.getSampleResultViewsList(),
    io_codedrills_proto_judge_judge_pb.TestResultView.toObject, includeInstance),
    processedTests: jspb.Message.getFieldWithDefault(msg, 8, 0),
    totalTests: jspb.Message.getFieldWithDefault(msg, 9, 0),
    firstIncorrectTestId: jspb.Message.getFieldWithDefault(msg, 10, 0),
    firstIncorrectTestSet: jspb.Message.getFieldWithDefault(msg, 11, ""),
    score: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatusResponse}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.SubmissionStatusResponse;
  return proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatusResponse}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setSubmissionId(value);
      break;
    case 2:
      var value = /** @type {!proto.io.codedrills.proto.judge.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setResult(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTimeTaken(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setMemoryTaken(value);
      break;
    case 6:
      var value = /** @type {!proto.io.codedrills.proto.judge.SubmissionType} */ (reader.readEnum());
      msg.setSubmissionType(value);
      break;
    case 7:
      var value = new io_codedrills_proto_judge_judge_pb.TestResultView;
      reader.readMessage(value,io_codedrills_proto_judge_judge_pb.TestResultView.deserializeBinaryFromReader);
      msg.addSampleResultViews(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProcessedTests(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalTests(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFirstIncorrectTestId(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstIncorrectTestSet(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setScore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubmissionId();
  if (f !== 0) {
    writer.writeFixed32(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getResult();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTimeTaken();
  if (f !== 0) {
    writer.writeFixed32(
      4,
      f
    );
  }
  f = message.getMemoryTaken();
  if (f !== 0) {
    writer.writeFixed32(
      5,
      f
    );
  }
  f = message.getSubmissionType();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getSampleResultViewsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      io_codedrills_proto_judge_judge_pb.TestResultView.serializeBinaryToWriter
    );
  }
  f = message.getProcessedTests();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getTotalTests();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getFirstIncorrectTestId();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getFirstIncorrectTestSet();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getScore();
  if (f !== 0.0) {
    writer.writeDouble(
      12,
      f
    );
  }
};


/**
 * optional fixed32 submission_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.prototype.getSubmissionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatusResponse} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.prototype.setSubmissionId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional io.codedrills.proto.judge.Status status = 2;
 * @return {!proto.io.codedrills.proto.judge.Status}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.prototype.getStatus = function() {
  return /** @type {!proto.io.codedrills.proto.judge.Status} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.io.codedrills.proto.judge.Status} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatusResponse} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string result = 3;
 * @return {string}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.prototype.getResult = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatusResponse} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.prototype.setResult = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional fixed32 time_taken = 4;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.prototype.getTimeTaken = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatusResponse} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.prototype.setTimeTaken = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional fixed32 memory_taken = 5;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.prototype.getMemoryTaken = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatusResponse} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.prototype.setMemoryTaken = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional io.codedrills.proto.judge.SubmissionType submission_type = 6;
 * @return {!proto.io.codedrills.proto.judge.SubmissionType}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.prototype.getSubmissionType = function() {
  return /** @type {!proto.io.codedrills.proto.judge.SubmissionType} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.io.codedrills.proto.judge.SubmissionType} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatusResponse} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.prototype.setSubmissionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * repeated io.codedrills.proto.judge.TestResultView sample_result_views = 7;
 * @return {!Array<!proto.io.codedrills.proto.judge.TestResultView>}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.prototype.getSampleResultViewsList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.judge.TestResultView>} */ (
    jspb.Message.getRepeatedWrapperField(this, io_codedrills_proto_judge_judge_pb.TestResultView, 7));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.judge.TestResultView>} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatusResponse} returns this
*/
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.prototype.setSampleResultViewsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.io.codedrills.proto.judge.TestResultView=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.judge.TestResultView}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.prototype.addSampleResultViews = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.io.codedrills.proto.judge.TestResultView, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatusResponse} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.prototype.clearSampleResultViewsList = function() {
  return this.setSampleResultViewsList([]);
};


/**
 * optional int32 processed_tests = 8;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.prototype.getProcessedTests = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatusResponse} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.prototype.setProcessedTests = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 total_tests = 9;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.prototype.getTotalTests = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatusResponse} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.prototype.setTotalTests = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 first_incorrect_test_id = 10;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.prototype.getFirstIncorrectTestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatusResponse} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.prototype.setFirstIncorrectTestId = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string first_incorrect_test_set = 11;
 * @return {string}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.prototype.getFirstIncorrectTestSet = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatusResponse} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.prototype.setFirstIncorrectTestSet = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional double score = 12;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatusResponse} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionStatusResponse.prototype.setScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.SubmissionStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.SubmissionStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0),
    result: jspb.Message.getFieldWithDefault(msg, 3, ""),
    timeTaken: jspb.Message.getFieldWithDefault(msg, 4, 0),
    memoryTaken: jspb.Message.getFieldWithDefault(msg, 5, 0),
    submittedOn: jspb.Message.getFieldWithDefault(msg, 6, 0),
    parentId: jspb.Message.getFieldWithDefault(msg, 7, 0),
    userPreview: (f = msg.getUserPreview()) && io_codedrills_proto_content_preview_pb.UserPreview.toObject(includeInstance, f),
    language: jspb.Message.getFieldWithDefault(msg, 9, 0),
    score: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatus}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.SubmissionStatus;
  return proto.io.codedrills.proto.judge.master.SubmissionStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatus}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.io.codedrills.proto.judge.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setResult(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTimeTaken(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setMemoryTaken(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubmittedOn(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setParentId(value);
      break;
    case 8:
      var value = new io_codedrills_proto_content_preview_pb.UserPreview;
      reader.readMessage(value,io_codedrills_proto_content_preview_pb.UserPreview.deserializeBinaryFromReader);
      msg.setUserPreview(value);
      break;
    case 9:
      var value = /** @type {!proto.io.codedrills.proto.judge.Language} */ (reader.readEnum());
      msg.setLanguage(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setScore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.SubmissionStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.SubmissionStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeFixed32(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getResult();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTimeTaken();
  if (f !== 0) {
    writer.writeFixed32(
      4,
      f
    );
  }
  f = message.getMemoryTaken();
  if (f !== 0) {
    writer.writeFixed32(
      5,
      f
    );
  }
  f = message.getSubmittedOn();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getParentId();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getUserPreview();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      io_codedrills_proto_content_preview_pb.UserPreview.serializeBinaryToWriter
    );
  }
  f = message.getLanguage();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getScore();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
};


/**
 * optional fixed32 id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatus.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatus} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionStatus.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional io.codedrills.proto.judge.Status status = 2;
 * @return {!proto.io.codedrills.proto.judge.Status}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatus.prototype.getStatus = function() {
  return /** @type {!proto.io.codedrills.proto.judge.Status} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.io.codedrills.proto.judge.Status} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatus} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionStatus.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string result = 3;
 * @return {string}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatus.prototype.getResult = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatus} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionStatus.prototype.setResult = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional fixed32 time_taken = 4;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatus.prototype.getTimeTaken = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatus} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionStatus.prototype.setTimeTaken = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional fixed32 memory_taken = 5;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatus.prototype.getMemoryTaken = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatus} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionStatus.prototype.setMemoryTaken = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 submitted_on = 6;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatus.prototype.getSubmittedOn = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatus} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionStatus.prototype.setSubmittedOn = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 parent_id = 7;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatus.prototype.getParentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatus} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionStatus.prototype.setParentId = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional io.codedrills.proto.content.UserPreview user_preview = 8;
 * @return {?proto.io.codedrills.proto.content.UserPreview}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatus.prototype.getUserPreview = function() {
  return /** @type{?proto.io.codedrills.proto.content.UserPreview} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_preview_pb.UserPreview, 8));
};


/**
 * @param {?proto.io.codedrills.proto.content.UserPreview|undefined} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatus} returns this
*/
proto.io.codedrills.proto.judge.master.SubmissionStatus.prototype.setUserPreview = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatus} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionStatus.prototype.clearUserPreview = function() {
  return this.setUserPreview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatus.prototype.hasUserPreview = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional io.codedrills.proto.judge.Language language = 9;
 * @return {!proto.io.codedrills.proto.judge.Language}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatus.prototype.getLanguage = function() {
  return /** @type {!proto.io.codedrills.proto.judge.Language} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.io.codedrills.proto.judge.Language} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatus} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionStatus.prototype.setLanguage = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional double score = 10;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatus.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatus} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionStatus.prototype.setScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    problemId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    parentId: (f = msg.getParentId()) && io_codedrills_proto_content_content_pb.ContentId.toObject(includeInstance, f),
    paginationQuery: (f = msg.getPaginationQuery()) && io_codedrills_proto_content_pagination_pb.PaginationQuery.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest}
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest;
  return proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest}
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProblemId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = new io_codedrills_proto_content_content_pb.ContentId;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.ContentId.deserializeBinaryFromReader);
      msg.setParentId(value);
      break;
    case 4:
      var value = new io_codedrills_proto_content_pagination_pb.PaginationQuery;
      reader.readMessage(value,io_codedrills_proto_content_pagination_pb.PaginationQuery.deserializeBinaryFromReader);
      msg.setPaginationQuery(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProblemId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getParentId();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      io_codedrills_proto_content_content_pb.ContentId.serializeBinaryToWriter
    );
  }
  f = message.getPaginationQuery();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      io_codedrills_proto_content_pagination_pb.PaginationQuery.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 problem_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest.prototype.getProblemId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest.prototype.setProblemId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional io.codedrills.proto.content.ContentId parent_id = 3;
 * @return {?proto.io.codedrills.proto.content.ContentId}
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest.prototype.getParentId = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentId} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.ContentId, 3));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentId|undefined} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest} returns this
*/
proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest.prototype.setParentId = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest.prototype.clearParentId = function() {
  return this.setParentId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest.prototype.hasParentId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional io.codedrills.proto.content.PaginationQuery pagination_query = 4;
 * @return {?proto.io.codedrills.proto.content.PaginationQuery}
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest.prototype.getPaginationQuery = function() {
  return /** @type{?proto.io.codedrills.proto.content.PaginationQuery} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_pagination_pb.PaginationQuery, 4));
};


/**
 * @param {?proto.io.codedrills.proto.content.PaginationQuery|undefined} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest} returns this
*/
proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest.prototype.setPaginationQuery = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest.prototype.clearPaginationQuery = function() {
  return this.setPaginationQuery(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryRequest.prototype.hasPaginationQuery = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    problemId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    submissionStatusList: jspb.Message.toObjectList(msg.getSubmissionStatusList(),
    proto.io.codedrills.proto.judge.master.SubmissionStatus.toObject, includeInstance),
    paginationResponse: (f = msg.getPaginationResponse()) && io_codedrills_proto_content_pagination_pb.PaginationResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse}
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse;
  return proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse}
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProblemId(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.judge.master.SubmissionStatus;
      reader.readMessage(value,proto.io.codedrills.proto.judge.master.SubmissionStatus.deserializeBinaryFromReader);
      msg.addSubmissionStatus(value);
      break;
    case 3:
      var value = new io_codedrills_proto_content_pagination_pb.PaginationResponse;
      reader.readMessage(value,io_codedrills_proto_content_pagination_pb.PaginationResponse.deserializeBinaryFromReader);
      msg.setPaginationResponse(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProblemId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSubmissionStatusList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.io.codedrills.proto.judge.master.SubmissionStatus.serializeBinaryToWriter
    );
  }
  f = message.getPaginationResponse();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      io_codedrills_proto_content_pagination_pb.PaginationResponse.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 problem_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse.prototype.getProblemId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse.prototype.setProblemId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated SubmissionStatus submission_status = 2;
 * @return {!Array<!proto.io.codedrills.proto.judge.master.SubmissionStatus>}
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse.prototype.getSubmissionStatusList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.judge.master.SubmissionStatus>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.judge.master.SubmissionStatus, 2));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.judge.master.SubmissionStatus>} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse} returns this
*/
proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse.prototype.setSubmissionStatusList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionStatus=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatus}
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse.prototype.addSubmissionStatus = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.io.codedrills.proto.judge.master.SubmissionStatus, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse.prototype.clearSubmissionStatusList = function() {
  return this.setSubmissionStatusList([]);
};


/**
 * optional io.codedrills.proto.content.PaginationResponse pagination_response = 3;
 * @return {?proto.io.codedrills.proto.content.PaginationResponse}
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse.prototype.getPaginationResponse = function() {
  return /** @type{?proto.io.codedrills.proto.content.PaginationResponse} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_pagination_pb.PaginationResponse, 3));
};


/**
 * @param {?proto.io.codedrills.proto.content.PaginationResponse|undefined} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse} returns this
*/
proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse.prototype.setPaginationResponse = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse.prototype.clearPaginationResponse = function() {
  return this.setPaginationResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.master.SubmissionHistoryResponse.prototype.hasPaginationResponse = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    problemId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    parentId: (f = msg.getParentId()) && io_codedrills_proto_content_content_pb.ContentId.toObject(includeInstance, f),
    paginationQuery: (f = msg.getPaginationQuery()) && io_codedrills_proto_content_pagination_pb.PaginationQuery.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest}
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest;
  return proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest}
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProblemId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = new io_codedrills_proto_content_content_pb.ContentId;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.ContentId.deserializeBinaryFromReader);
      msg.setParentId(value);
      break;
    case 4:
      var value = new io_codedrills_proto_content_pagination_pb.PaginationQuery;
      reader.readMessage(value,io_codedrills_proto_content_pagination_pb.PaginationQuery.deserializeBinaryFromReader);
      msg.setPaginationQuery(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProblemId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getParentId();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      io_codedrills_proto_content_content_pb.ContentId.serializeBinaryToWriter
    );
  }
  f = message.getPaginationQuery();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      io_codedrills_proto_content_pagination_pb.PaginationQuery.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 problem_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest.prototype.getProblemId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest} returns this
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest.prototype.setProblemId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest} returns this
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional io.codedrills.proto.content.ContentId parent_id = 3;
 * @return {?proto.io.codedrills.proto.content.ContentId}
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest.prototype.getParentId = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentId} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.ContentId, 3));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentId|undefined} value
 * @return {!proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest} returns this
*/
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest.prototype.setParentId = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest} returns this
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest.prototype.clearParentId = function() {
  return this.setParentId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest.prototype.hasParentId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional io.codedrills.proto.content.PaginationQuery pagination_query = 4;
 * @return {?proto.io.codedrills.proto.content.PaginationQuery}
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest.prototype.getPaginationQuery = function() {
  return /** @type{?proto.io.codedrills.proto.content.PaginationQuery} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_pagination_pb.PaginationQuery, 4));
};


/**
 * @param {?proto.io.codedrills.proto.content.PaginationQuery|undefined} value
 * @return {!proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest} returns this
*/
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest.prototype.setPaginationQuery = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest} returns this
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest.prototype.clearPaginationQuery = function() {
  return this.setPaginationQuery(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryRequest.prototype.hasPaginationQuery = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    problemId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    submissionStatusList: jspb.Message.toObjectList(msg.getSubmissionStatusList(),
    proto.io.codedrills.proto.judge.master.SubmissionStatus.toObject, includeInstance),
    paginationResponse: (f = msg.getPaginationResponse()) && io_codedrills_proto_content_pagination_pb.PaginationResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse}
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse;
  return proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse}
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProblemId(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.judge.master.SubmissionStatus;
      reader.readMessage(value,proto.io.codedrills.proto.judge.master.SubmissionStatus.deserializeBinaryFromReader);
      msg.addSubmissionStatus(value);
      break;
    case 3:
      var value = new io_codedrills_proto_content_pagination_pb.PaginationResponse;
      reader.readMessage(value,io_codedrills_proto_content_pagination_pb.PaginationResponse.deserializeBinaryFromReader);
      msg.setPaginationResponse(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProblemId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSubmissionStatusList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.io.codedrills.proto.judge.master.SubmissionStatus.serializeBinaryToWriter
    );
  }
  f = message.getPaginationResponse();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      io_codedrills_proto_content_pagination_pb.PaginationResponse.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 problem_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse.prototype.getProblemId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse} returns this
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse.prototype.setProblemId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated SubmissionStatus submission_status = 2;
 * @return {!Array<!proto.io.codedrills.proto.judge.master.SubmissionStatus>}
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse.prototype.getSubmissionStatusList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.judge.master.SubmissionStatus>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.judge.master.SubmissionStatus, 2));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.judge.master.SubmissionStatus>} value
 * @return {!proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse} returns this
*/
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse.prototype.setSubmissionStatusList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionStatus=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatus}
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse.prototype.addSubmissionStatus = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.io.codedrills.proto.judge.master.SubmissionStatus, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse} returns this
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse.prototype.clearSubmissionStatusList = function() {
  return this.setSubmissionStatusList([]);
};


/**
 * optional io.codedrills.proto.content.PaginationResponse pagination_response = 3;
 * @return {?proto.io.codedrills.proto.content.PaginationResponse}
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse.prototype.getPaginationResponse = function() {
  return /** @type{?proto.io.codedrills.proto.content.PaginationResponse} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_pagination_pb.PaginationResponse, 3));
};


/**
 * @param {?proto.io.codedrills.proto.content.PaginationResponse|undefined} value
 * @return {!proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse} returns this
*/
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse.prototype.setPaginationResponse = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse} returns this
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse.prototype.clearPaginationResponse = function() {
  return this.setPaginationResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.master.TestSubmissionHistoryResponse.prototype.hasPaginationResponse = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.UserAttemptedProblemsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.UserAttemptedProblemsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.UserAttemptedProblemsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.UserAttemptedProblemsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.UserAttemptedProblemsRequest}
 */
proto.io.codedrills.proto.judge.master.UserAttemptedProblemsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.UserAttemptedProblemsRequest;
  return proto.io.codedrills.proto.judge.master.UserAttemptedProblemsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.UserAttemptedProblemsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.UserAttemptedProblemsRequest}
 */
proto.io.codedrills.proto.judge.master.UserAttemptedProblemsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.UserAttemptedProblemsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.UserAttemptedProblemsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.UserAttemptedProblemsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.UserAttemptedProblemsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.io.codedrills.proto.judge.master.UserAttemptedProblemsRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.master.UserAttemptedProblemsRequest} returns this
 */
proto.io.codedrills.proto.judge.master.UserAttemptedProblemsRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.UserAttemptedProblemsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.UserAttemptedProblemsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.UserAttemptedProblemsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.UserAttemptedProblemsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    problemStatusesMap: (f = msg.getProblemStatusesMap()) ? f.toObject(includeInstance, proto.io.codedrills.proto.judge.master.ProblemStatus.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.UserAttemptedProblemsResponse}
 */
proto.io.codedrills.proto.judge.master.UserAttemptedProblemsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.UserAttemptedProblemsResponse;
  return proto.io.codedrills.proto.judge.master.UserAttemptedProblemsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.UserAttemptedProblemsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.UserAttemptedProblemsResponse}
 */
proto.io.codedrills.proto.judge.master.UserAttemptedProblemsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getProblemStatusesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt32, jspb.BinaryReader.prototype.readMessage, proto.io.codedrills.proto.judge.master.ProblemStatus.deserializeBinaryFromReader, 0, new proto.io.codedrills.proto.judge.master.ProblemStatus());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.UserAttemptedProblemsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.UserAttemptedProblemsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.UserAttemptedProblemsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.UserAttemptedProblemsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProblemStatusesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeInt32, jspb.BinaryWriter.prototype.writeMessage, proto.io.codedrills.proto.judge.master.ProblemStatus.serializeBinaryToWriter);
  }
};


/**
 * map<int32, ProblemStatus> problem_statuses = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,!proto.io.codedrills.proto.judge.master.ProblemStatus>}
 */
proto.io.codedrills.proto.judge.master.UserAttemptedProblemsResponse.prototype.getProblemStatusesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,!proto.io.codedrills.proto.judge.master.ProblemStatus>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.io.codedrills.proto.judge.master.ProblemStatus));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.io.codedrills.proto.judge.master.UserAttemptedProblemsResponse} returns this
 */
proto.io.codedrills.proto.judge.master.UserAttemptedProblemsResponse.prototype.clearProblemStatusesMap = function() {
  this.getProblemStatusesMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.ProblemStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.ProblemStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.ProblemStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.ProblemStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    problemId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.ProblemStatus}
 */
proto.io.codedrills.proto.judge.master.ProblemStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.ProblemStatus;
  return proto.io.codedrills.proto.judge.master.ProblemStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.ProblemStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.ProblemStatus}
 */
proto.io.codedrills.proto.judge.master.ProblemStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProblemId(value);
      break;
    case 2:
      var value = /** @type {!proto.io.codedrills.proto.judge.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.ProblemStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.ProblemStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.ProblemStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.ProblemStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProblemId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional int32 problem_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.ProblemStatus.prototype.getProblemId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.ProblemStatus} returns this
 */
proto.io.codedrills.proto.judge.master.ProblemStatus.prototype.setProblemId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional io.codedrills.proto.judge.Status status = 2;
 * @return {!proto.io.codedrills.proto.judge.Status}
 */
proto.io.codedrills.proto.judge.master.ProblemStatus.prototype.getStatus = function() {
  return /** @type {!proto.io.codedrills.proto.judge.Status} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.io.codedrills.proto.judge.Status} value
 * @return {!proto.io.codedrills.proto.judge.master.ProblemStatus} returns this
 */
proto.io.codedrills.proto.judge.master.ProblemStatus.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.SubmissionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.SubmissionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.SubmissionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    submissionId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionRequest}
 */
proto.io.codedrills.proto.judge.master.SubmissionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.SubmissionRequest;
  return proto.io.codedrills.proto.judge.master.SubmissionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionRequest}
 */
proto.io.codedrills.proto.judge.master.SubmissionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSubmissionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.SubmissionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.SubmissionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.SubmissionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubmissionId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 submission_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.SubmissionRequest.prototype.getSubmissionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionRequest} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionRequest.prototype.setSubmissionId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.judge.master.SubmissionResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.SubmissionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.SubmissionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.SubmissionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    submission: (f = msg.getSubmission()) && io_codedrills_proto_judge_judge_pb.Submission.toObject(includeInstance, f),
    testRunResultsList: jspb.Message.toObjectList(msg.getTestRunResultsList(),
    io_codedrills_proto_judge_judge_pb.TestRunResult.toObject, includeInstance),
    problemPreview: (f = msg.getProblemPreview()) && io_codedrills_proto_content_preview_pb.ContentPreview.toObject(includeInstance, f),
    userPreview: (f = msg.getUserPreview()) && io_codedrills_proto_content_preview_pb.UserPreview.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionResponse}
 */
proto.io.codedrills.proto.judge.master.SubmissionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.SubmissionResponse;
  return proto.io.codedrills.proto.judge.master.SubmissionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionResponse}
 */
proto.io.codedrills.proto.judge.master.SubmissionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_judge_judge_pb.Submission;
      reader.readMessage(value,io_codedrills_proto_judge_judge_pb.Submission.deserializeBinaryFromReader);
      msg.setSubmission(value);
      break;
    case 2:
      var value = new io_codedrills_proto_judge_judge_pb.TestRunResult;
      reader.readMessage(value,io_codedrills_proto_judge_judge_pb.TestRunResult.deserializeBinaryFromReader);
      msg.addTestRunResults(value);
      break;
    case 4:
      var value = new io_codedrills_proto_content_preview_pb.ContentPreview;
      reader.readMessage(value,io_codedrills_proto_content_preview_pb.ContentPreview.deserializeBinaryFromReader);
      msg.setProblemPreview(value);
      break;
    case 5:
      var value = new io_codedrills_proto_content_preview_pb.UserPreview;
      reader.readMessage(value,io_codedrills_proto_content_preview_pb.UserPreview.deserializeBinaryFromReader);
      msg.setUserPreview(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.SubmissionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.SubmissionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.SubmissionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubmission();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_judge_judge_pb.Submission.serializeBinaryToWriter
    );
  }
  f = message.getTestRunResultsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      io_codedrills_proto_judge_judge_pb.TestRunResult.serializeBinaryToWriter
    );
  }
  f = message.getProblemPreview();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      io_codedrills_proto_content_preview_pb.ContentPreview.serializeBinaryToWriter
    );
  }
  f = message.getUserPreview();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      io_codedrills_proto_content_preview_pb.UserPreview.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.judge.Submission submission = 1;
 * @return {?proto.io.codedrills.proto.judge.Submission}
 */
proto.io.codedrills.proto.judge.master.SubmissionResponse.prototype.getSubmission = function() {
  return /** @type{?proto.io.codedrills.proto.judge.Submission} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_judge_judge_pb.Submission, 1));
};


/**
 * @param {?proto.io.codedrills.proto.judge.Submission|undefined} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionResponse} returns this
*/
proto.io.codedrills.proto.judge.master.SubmissionResponse.prototype.setSubmission = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionResponse} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionResponse.prototype.clearSubmission = function() {
  return this.setSubmission(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.master.SubmissionResponse.prototype.hasSubmission = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated io.codedrills.proto.judge.TestRunResult test_run_results = 2;
 * @return {!Array<!proto.io.codedrills.proto.judge.TestRunResult>}
 */
proto.io.codedrills.proto.judge.master.SubmissionResponse.prototype.getTestRunResultsList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.judge.TestRunResult>} */ (
    jspb.Message.getRepeatedWrapperField(this, io_codedrills_proto_judge_judge_pb.TestRunResult, 2));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.judge.TestRunResult>} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionResponse} returns this
*/
proto.io.codedrills.proto.judge.master.SubmissionResponse.prototype.setTestRunResultsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.io.codedrills.proto.judge.TestRunResult=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.judge.TestRunResult}
 */
proto.io.codedrills.proto.judge.master.SubmissionResponse.prototype.addTestRunResults = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.io.codedrills.proto.judge.TestRunResult, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionResponse} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionResponse.prototype.clearTestRunResultsList = function() {
  return this.setTestRunResultsList([]);
};


/**
 * optional io.codedrills.proto.content.ContentPreview problem_preview = 4;
 * @return {?proto.io.codedrills.proto.content.ContentPreview}
 */
proto.io.codedrills.proto.judge.master.SubmissionResponse.prototype.getProblemPreview = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentPreview} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_preview_pb.ContentPreview, 4));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentPreview|undefined} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionResponse} returns this
*/
proto.io.codedrills.proto.judge.master.SubmissionResponse.prototype.setProblemPreview = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionResponse} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionResponse.prototype.clearProblemPreview = function() {
  return this.setProblemPreview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.master.SubmissionResponse.prototype.hasProblemPreview = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional io.codedrills.proto.content.UserPreview user_preview = 5;
 * @return {?proto.io.codedrills.proto.content.UserPreview}
 */
proto.io.codedrills.proto.judge.master.SubmissionResponse.prototype.getUserPreview = function() {
  return /** @type{?proto.io.codedrills.proto.content.UserPreview} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_preview_pb.UserPreview, 5));
};


/**
 * @param {?proto.io.codedrills.proto.content.UserPreview|undefined} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionResponse} returns this
*/
proto.io.codedrills.proto.judge.master.SubmissionResponse.prototype.setUserPreview = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionResponse} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionResponse.prototype.clearUserPreview = function() {
  return this.setUserPreview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.master.SubmissionResponse.prototype.hasUserPreview = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.SubmissionStatsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionStatsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.SubmissionStatsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    problemId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatsRequest}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.SubmissionStatsRequest;
  return proto.io.codedrills.proto.judge.master.SubmissionStatsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionStatsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatsRequest}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProblemId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.SubmissionStatsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionStatsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.SubmissionStatsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProblemId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 problem_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatsRequest.prototype.getProblemId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatsRequest} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionStatsRequest.prototype.setProblemId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.SubmissionStatsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionStatsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.SubmissionStatsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    solved: jspb.Message.getFieldWithDefault(msg, 4, 0),
    attempted: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatsResponse}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.SubmissionStatsResponse;
  return proto.io.codedrills.proto.judge.master.SubmissionStatsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionStatsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatsResponse}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSolved(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAttempted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.SubmissionStatsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.SubmissionStatsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.SubmissionStatsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSolved();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getAttempted();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional int32 solved = 4;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatsResponse.prototype.getSolved = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatsResponse} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionStatsResponse.prototype.setSolved = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 attempted = 5;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.SubmissionStatsResponse.prototype.getAttempted = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.SubmissionStatsResponse} returns this
 */
proto.io.codedrills.proto.judge.master.SubmissionStatsResponse.prototype.setAttempted = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contestId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryRequest}
 */
proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryRequest;
  return proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryRequest}
 */
proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContestId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 contest_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryRequest.prototype.getContestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryRequest} returns this
 */
proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryRequest.prototype.setContestId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    submissionSummaryList: jspb.Message.toObjectList(msg.getSubmissionSummaryList(),
    io_codedrills_proto_judge_judge_pb.SubmissionSummary.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse}
 */
proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse;
  return proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse}
 */
proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_judge_judge_pb.SubmissionSummary;
      reader.readMessage(value,io_codedrills_proto_judge_judge_pb.SubmissionSummary.deserializeBinaryFromReader);
      msg.addSubmissionSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubmissionSummaryList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      io_codedrills_proto_judge_judge_pb.SubmissionSummary.serializeBinaryToWriter
    );
  }
};


/**
 * repeated io.codedrills.proto.judge.SubmissionSummary submission_summary = 1;
 * @return {!Array<!proto.io.codedrills.proto.judge.SubmissionSummary>}
 */
proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse.prototype.getSubmissionSummaryList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.judge.SubmissionSummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, io_codedrills_proto_judge_judge_pb.SubmissionSummary, 1));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.judge.SubmissionSummary>} value
 * @return {!proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse} returns this
*/
proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse.prototype.setSubmissionSummaryList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.io.codedrills.proto.judge.SubmissionSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.judge.SubmissionSummary}
 */
proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse.prototype.addSubmissionSummary = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.io.codedrills.proto.judge.SubmissionSummary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse} returns this
 */
proto.io.codedrills.proto.judge.master.AllContestSubmissionSummaryResponse.prototype.clearSubmissionSummaryList = function() {
  return this.setSubmissionSummaryList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.ServerTimeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.ServerTimeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.ServerTimeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.ServerTimeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.ServerTimeRequest}
 */
proto.io.codedrills.proto.judge.master.ServerTimeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.ServerTimeRequest;
  return proto.io.codedrills.proto.judge.master.ServerTimeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.ServerTimeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.ServerTimeRequest}
 */
proto.io.codedrills.proto.judge.master.ServerTimeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.ServerTimeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.ServerTimeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.ServerTimeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.ServerTimeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.ServerTimeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.ServerTimeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.ServerTimeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.ServerTimeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    serverTime: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.ServerTimeResponse}
 */
proto.io.codedrills.proto.judge.master.ServerTimeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.ServerTimeResponse;
  return proto.io.codedrills.proto.judge.master.ServerTimeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.ServerTimeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.ServerTimeResponse}
 */
proto.io.codedrills.proto.judge.master.ServerTimeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setServerTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.ServerTimeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.ServerTimeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.ServerTimeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.ServerTimeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServerTime();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 server_time = 1;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.ServerTimeResponse.prototype.getServerTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.ServerTimeResponse} returns this
 */
proto.io.codedrills.proto.judge.master.ServerTimeResponse.prototype.setServerTime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.judge.master.RejudgeRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.RejudgeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.RejudgeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.RejudgeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.RejudgeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    minSubmissionId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    maxSubmissionId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    statusList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.RejudgeRequest}
 */
proto.io.codedrills.proto.judge.master.RejudgeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.RejudgeRequest;
  return proto.io.codedrills.proto.judge.master.RejudgeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.RejudgeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.RejudgeRequest}
 */
proto.io.codedrills.proto.judge.master.RejudgeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContentId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinSubmissionId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxSubmissionId(value);
      break;
    case 4:
      var value = /** @type {!Array<!proto.io.codedrills.proto.judge.Status>} */ (reader.readPackedEnum());
      msg.setStatusList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.RejudgeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.RejudgeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.RejudgeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.RejudgeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMinSubmissionId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getMaxSubmissionId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getStatusList();
  if (f.length > 0) {
    writer.writePackedEnum(
      4,
      f
    );
  }
};


/**
 * optional int32 content_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.RejudgeRequest.prototype.getContentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.RejudgeRequest} returns this
 */
proto.io.codedrills.proto.judge.master.RejudgeRequest.prototype.setContentId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 min_submission_id = 2;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.RejudgeRequest.prototype.getMinSubmissionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.RejudgeRequest} returns this
 */
proto.io.codedrills.proto.judge.master.RejudgeRequest.prototype.setMinSubmissionId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 max_submission_id = 3;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.RejudgeRequest.prototype.getMaxSubmissionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.RejudgeRequest} returns this
 */
proto.io.codedrills.proto.judge.master.RejudgeRequest.prototype.setMaxSubmissionId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated io.codedrills.proto.judge.Status status = 4;
 * @return {!Array<!proto.io.codedrills.proto.judge.Status>}
 */
proto.io.codedrills.proto.judge.master.RejudgeRequest.prototype.getStatusList = function() {
  return /** @type {!Array<!proto.io.codedrills.proto.judge.Status>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.judge.Status>} value
 * @return {!proto.io.codedrills.proto.judge.master.RejudgeRequest} returns this
 */
proto.io.codedrills.proto.judge.master.RejudgeRequest.prototype.setStatusList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {!proto.io.codedrills.proto.judge.Status} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.judge.master.RejudgeRequest} returns this
 */
proto.io.codedrills.proto.judge.master.RejudgeRequest.prototype.addStatus = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.judge.master.RejudgeRequest} returns this
 */
proto.io.codedrills.proto.judge.master.RejudgeRequest.prototype.clearStatusList = function() {
  return this.setStatusList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.RejudgeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.RejudgeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.RejudgeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.RejudgeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    rejudge: (f = msg.getRejudge()) && io_codedrills_proto_judge_judge_pb.Rejudge.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.RejudgeResponse}
 */
proto.io.codedrills.proto.judge.master.RejudgeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.RejudgeResponse;
  return proto.io.codedrills.proto.judge.master.RejudgeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.RejudgeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.RejudgeResponse}
 */
proto.io.codedrills.proto.judge.master.RejudgeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_judge_judge_pb.Rejudge;
      reader.readMessage(value,io_codedrills_proto_judge_judge_pb.Rejudge.deserializeBinaryFromReader);
      msg.setRejudge(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.RejudgeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.RejudgeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.RejudgeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.RejudgeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRejudge();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_judge_judge_pb.Rejudge.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.judge.Rejudge rejudge = 1;
 * @return {?proto.io.codedrills.proto.judge.Rejudge}
 */
proto.io.codedrills.proto.judge.master.RejudgeResponse.prototype.getRejudge = function() {
  return /** @type{?proto.io.codedrills.proto.judge.Rejudge} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_judge_judge_pb.Rejudge, 1));
};


/**
 * @param {?proto.io.codedrills.proto.judge.Rejudge|undefined} value
 * @return {!proto.io.codedrills.proto.judge.master.RejudgeResponse} returns this
*/
proto.io.codedrills.proto.judge.master.RejudgeResponse.prototype.setRejudge = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.master.RejudgeResponse} returns this
 */
proto.io.codedrills.proto.judge.master.RejudgeResponse.prototype.clearRejudge = function() {
  return this.setRejudge(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.master.RejudgeResponse.prototype.hasRejudge = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.FetchRejudgeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.FetchRejudgeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.FetchRejudgeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.FetchRejudgeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.FetchRejudgeRequest}
 */
proto.io.codedrills.proto.judge.master.FetchRejudgeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.FetchRejudgeRequest;
  return proto.io.codedrills.proto.judge.master.FetchRejudgeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.FetchRejudgeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.FetchRejudgeRequest}
 */
proto.io.codedrills.proto.judge.master.FetchRejudgeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.FetchRejudgeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.FetchRejudgeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.FetchRejudgeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.FetchRejudgeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 content_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.FetchRejudgeRequest.prototype.getContentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.FetchRejudgeRequest} returns this
 */
proto.io.codedrills.proto.judge.master.FetchRejudgeRequest.prototype.setContentId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.judge.master.FetchRejudgeResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.FetchRejudgeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.FetchRejudgeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.FetchRejudgeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.FetchRejudgeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    rejudgesList: jspb.Message.toObjectList(msg.getRejudgesList(),
    io_codedrills_proto_judge_judge_pb.Rejudge.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.FetchRejudgeResponse}
 */
proto.io.codedrills.proto.judge.master.FetchRejudgeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.FetchRejudgeResponse;
  return proto.io.codedrills.proto.judge.master.FetchRejudgeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.FetchRejudgeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.FetchRejudgeResponse}
 */
proto.io.codedrills.proto.judge.master.FetchRejudgeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_judge_judge_pb.Rejudge;
      reader.readMessage(value,io_codedrills_proto_judge_judge_pb.Rejudge.deserializeBinaryFromReader);
      msg.addRejudges(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.FetchRejudgeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.FetchRejudgeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.FetchRejudgeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.FetchRejudgeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRejudgesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      io_codedrills_proto_judge_judge_pb.Rejudge.serializeBinaryToWriter
    );
  }
};


/**
 * repeated io.codedrills.proto.judge.Rejudge rejudges = 1;
 * @return {!Array<!proto.io.codedrills.proto.judge.Rejudge>}
 */
proto.io.codedrills.proto.judge.master.FetchRejudgeResponse.prototype.getRejudgesList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.judge.Rejudge>} */ (
    jspb.Message.getRepeatedWrapperField(this, io_codedrills_proto_judge_judge_pb.Rejudge, 1));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.judge.Rejudge>} value
 * @return {!proto.io.codedrills.proto.judge.master.FetchRejudgeResponse} returns this
*/
proto.io.codedrills.proto.judge.master.FetchRejudgeResponse.prototype.setRejudgesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.io.codedrills.proto.judge.Rejudge=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.judge.Rejudge}
 */
proto.io.codedrills.proto.judge.master.FetchRejudgeResponse.prototype.addRejudges = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.io.codedrills.proto.judge.Rejudge, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.judge.master.FetchRejudgeResponse} returns this
 */
proto.io.codedrills.proto.judge.master.FetchRejudgeResponse.prototype.clearRejudgesList = function() {
  return this.setRejudgesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentId: (f = msg.getContentId()) && io_codedrills_proto_content_content_pb.ContentId.toObject(includeInstance, f),
    paginationQuery: (f = msg.getPaginationQuery()) && io_codedrills_proto_content_pagination_pb.PaginationQuery.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest}
 */
proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest;
  return proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest}
 */
proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_content_pb.ContentId;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.ContentId.deserializeBinaryFromReader);
      msg.setContentId(value);
      break;
    case 2:
      var value = new io_codedrills_proto_content_pagination_pb.PaginationQuery;
      reader.readMessage(value,io_codedrills_proto_content_pagination_pb.PaginationQuery.deserializeBinaryFromReader);
      msg.setPaginationQuery(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_content_pb.ContentId.serializeBinaryToWriter
    );
  }
  f = message.getPaginationQuery();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      io_codedrills_proto_content_pagination_pb.PaginationQuery.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.ContentId content_id = 1;
 * @return {?proto.io.codedrills.proto.content.ContentId}
 */
proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest.prototype.getContentId = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentId} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.ContentId, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentId|undefined} value
 * @return {!proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest} returns this
*/
proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest.prototype.setContentId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest} returns this
 */
proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest.prototype.clearContentId = function() {
  return this.setContentId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest.prototype.hasContentId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional io.codedrills.proto.content.PaginationQuery pagination_query = 2;
 * @return {?proto.io.codedrills.proto.content.PaginationQuery}
 */
proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest.prototype.getPaginationQuery = function() {
  return /** @type{?proto.io.codedrills.proto.content.PaginationQuery} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_pagination_pb.PaginationQuery, 2));
};


/**
 * @param {?proto.io.codedrills.proto.content.PaginationQuery|undefined} value
 * @return {!proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest} returns this
*/
proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest.prototype.setPaginationQuery = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest} returns this
 */
proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest.prototype.clearPaginationQuery = function() {
  return this.setPaginationQuery(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.master.ContestSubmissionsRequest.prototype.hasPaginationQuery = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    submissionPreviewsList: jspb.Message.toObjectList(msg.getSubmissionPreviewsList(),
    io_codedrills_proto_content_preview_pb.SubmissionPreview.toObject, includeInstance),
    paginationResponse: (f = msg.getPaginationResponse()) && io_codedrills_proto_content_pagination_pb.PaginationResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse}
 */
proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse;
  return proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse}
 */
proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_preview_pb.SubmissionPreview;
      reader.readMessage(value,io_codedrills_proto_content_preview_pb.SubmissionPreview.deserializeBinaryFromReader);
      msg.addSubmissionPreviews(value);
      break;
    case 2:
      var value = new io_codedrills_proto_content_pagination_pb.PaginationResponse;
      reader.readMessage(value,io_codedrills_proto_content_pagination_pb.PaginationResponse.deserializeBinaryFromReader);
      msg.setPaginationResponse(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubmissionPreviewsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      io_codedrills_proto_content_preview_pb.SubmissionPreview.serializeBinaryToWriter
    );
  }
  f = message.getPaginationResponse();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      io_codedrills_proto_content_pagination_pb.PaginationResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated io.codedrills.proto.content.SubmissionPreview submission_previews = 1;
 * @return {!Array<!proto.io.codedrills.proto.content.SubmissionPreview>}
 */
proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse.prototype.getSubmissionPreviewsList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.SubmissionPreview>} */ (
    jspb.Message.getRepeatedWrapperField(this, io_codedrills_proto_content_preview_pb.SubmissionPreview, 1));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.SubmissionPreview>} value
 * @return {!proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse} returns this
*/
proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse.prototype.setSubmissionPreviewsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.SubmissionPreview=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.SubmissionPreview}
 */
proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse.prototype.addSubmissionPreviews = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.io.codedrills.proto.content.SubmissionPreview, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse} returns this
 */
proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse.prototype.clearSubmissionPreviewsList = function() {
  return this.setSubmissionPreviewsList([]);
};


/**
 * optional io.codedrills.proto.content.PaginationResponse pagination_response = 2;
 * @return {?proto.io.codedrills.proto.content.PaginationResponse}
 */
proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse.prototype.getPaginationResponse = function() {
  return /** @type{?proto.io.codedrills.proto.content.PaginationResponse} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_pagination_pb.PaginationResponse, 2));
};


/**
 * @param {?proto.io.codedrills.proto.content.PaginationResponse|undefined} value
 * @return {!proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse} returns this
*/
proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse.prototype.setPaginationResponse = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse} returns this
 */
proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse.prototype.clearPaginationResponse = function() {
  return this.setPaginationResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.master.ContestSubmissionsResponse.prototype.hasPaginationResponse = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.UploadContestSubmissionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.UploadContestSubmissionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.UploadContestSubmissionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.UploadContestSubmissionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contestId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.UploadContestSubmissionsRequest}
 */
proto.io.codedrills.proto.judge.master.UploadContestSubmissionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.UploadContestSubmissionsRequest;
  return proto.io.codedrills.proto.judge.master.UploadContestSubmissionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.UploadContestSubmissionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.UploadContestSubmissionsRequest}
 */
proto.io.codedrills.proto.judge.master.UploadContestSubmissionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.UploadContestSubmissionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.UploadContestSubmissionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.UploadContestSubmissionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.UploadContestSubmissionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContestId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 contest_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.UploadContestSubmissionsRequest.prototype.getContestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.UploadContestSubmissionsRequest} returns this
 */
proto.io.codedrills.proto.judge.master.UploadContestSubmissionsRequest.prototype.setContestId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.UploadContestSubmissionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.UploadContestSubmissionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.UploadContestSubmissionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.UploadContestSubmissionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.UploadContestSubmissionsResponse}
 */
proto.io.codedrills.proto.judge.master.UploadContestSubmissionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.UploadContestSubmissionsResponse;
  return proto.io.codedrills.proto.judge.master.UploadContestSubmissionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.UploadContestSubmissionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.UploadContestSubmissionsResponse}
 */
proto.io.codedrills.proto.judge.master.UploadContestSubmissionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.UploadContestSubmissionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.UploadContestSubmissionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.UploadContestSubmissionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.UploadContestSubmissionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    problemUrl: jspb.Message.getFieldWithDefault(msg, 1, ""),
    submissionTypeList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    statusList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    paginationQuery: (f = msg.getPaginationQuery()) && io_codedrills_proto_content_pagination_pb.PaginationQuery.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest}
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest;
  return proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest}
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProblemUrl(value);
      break;
    case 2:
      var value = /** @type {!Array<!proto.io.codedrills.proto.judge.SubmissionType>} */ (reader.readPackedEnum());
      msg.setSubmissionTypeList(value);
      break;
    case 3:
      var value = /** @type {!Array<!proto.io.codedrills.proto.judge.Status>} */ (reader.readPackedEnum());
      msg.setStatusList(value);
      break;
    case 4:
      var value = new io_codedrills_proto_content_pagination_pb.PaginationQuery;
      reader.readMessage(value,io_codedrills_proto_content_pagination_pb.PaginationQuery.deserializeBinaryFromReader);
      msg.setPaginationQuery(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProblemUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubmissionTypeList();
  if (f.length > 0) {
    writer.writePackedEnum(
      2,
      f
    );
  }
  f = message.getStatusList();
  if (f.length > 0) {
    writer.writePackedEnum(
      3,
      f
    );
  }
  f = message.getPaginationQuery();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      io_codedrills_proto_content_pagination_pb.PaginationQuery.serializeBinaryToWriter
    );
  }
};


/**
 * optional string problem_url = 1;
 * @return {string}
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest.prototype.getProblemUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest} returns this
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest.prototype.setProblemUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated io.codedrills.proto.judge.SubmissionType submission_type = 2;
 * @return {!Array<!proto.io.codedrills.proto.judge.SubmissionType>}
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest.prototype.getSubmissionTypeList = function() {
  return /** @type {!Array<!proto.io.codedrills.proto.judge.SubmissionType>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.judge.SubmissionType>} value
 * @return {!proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest} returns this
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest.prototype.setSubmissionTypeList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!proto.io.codedrills.proto.judge.SubmissionType} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest} returns this
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest.prototype.addSubmissionType = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest} returns this
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest.prototype.clearSubmissionTypeList = function() {
  return this.setSubmissionTypeList([]);
};


/**
 * repeated io.codedrills.proto.judge.Status status = 3;
 * @return {!Array<!proto.io.codedrills.proto.judge.Status>}
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest.prototype.getStatusList = function() {
  return /** @type {!Array<!proto.io.codedrills.proto.judge.Status>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.judge.Status>} value
 * @return {!proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest} returns this
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest.prototype.setStatusList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {!proto.io.codedrills.proto.judge.Status} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest} returns this
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest.prototype.addStatus = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest} returns this
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest.prototype.clearStatusList = function() {
  return this.setStatusList([]);
};


/**
 * optional io.codedrills.proto.content.PaginationQuery pagination_query = 4;
 * @return {?proto.io.codedrills.proto.content.PaginationQuery}
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest.prototype.getPaginationQuery = function() {
  return /** @type{?proto.io.codedrills.proto.content.PaginationQuery} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_pagination_pb.PaginationQuery, 4));
};


/**
 * @param {?proto.io.codedrills.proto.content.PaginationQuery|undefined} value
 * @return {!proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest} returns this
*/
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest.prototype.setPaginationQuery = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest} returns this
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest.prototype.clearPaginationQuery = function() {
  return this.setPaginationQuery(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminRequest.prototype.hasPaginationQuery = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    submissionPreviewList: jspb.Message.toObjectList(msg.getSubmissionPreviewList(),
    io_codedrills_proto_content_preview_pb.SubmissionPreview.toObject, includeInstance),
    paginationResponse: (f = msg.getPaginationResponse()) && io_codedrills_proto_content_pagination_pb.PaginationResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse}
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse;
  return proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse}
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_preview_pb.SubmissionPreview;
      reader.readMessage(value,io_codedrills_proto_content_preview_pb.SubmissionPreview.deserializeBinaryFromReader);
      msg.addSubmissionPreview(value);
      break;
    case 2:
      var value = new io_codedrills_proto_content_pagination_pb.PaginationResponse;
      reader.readMessage(value,io_codedrills_proto_content_pagination_pb.PaginationResponse.deserializeBinaryFromReader);
      msg.setPaginationResponse(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubmissionPreviewList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      io_codedrills_proto_content_preview_pb.SubmissionPreview.serializeBinaryToWriter
    );
  }
  f = message.getPaginationResponse();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      io_codedrills_proto_content_pagination_pb.PaginationResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated io.codedrills.proto.content.SubmissionPreview submission_preview = 1;
 * @return {!Array<!proto.io.codedrills.proto.content.SubmissionPreview>}
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse.prototype.getSubmissionPreviewList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.SubmissionPreview>} */ (
    jspb.Message.getRepeatedWrapperField(this, io_codedrills_proto_content_preview_pb.SubmissionPreview, 1));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.SubmissionPreview>} value
 * @return {!proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse} returns this
*/
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse.prototype.setSubmissionPreviewList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.SubmissionPreview=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.SubmissionPreview}
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse.prototype.addSubmissionPreview = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.io.codedrills.proto.content.SubmissionPreview, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse} returns this
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse.prototype.clearSubmissionPreviewList = function() {
  return this.setSubmissionPreviewList([]);
};


/**
 * optional io.codedrills.proto.content.PaginationResponse pagination_response = 2;
 * @return {?proto.io.codedrills.proto.content.PaginationResponse}
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse.prototype.getPaginationResponse = function() {
  return /** @type{?proto.io.codedrills.proto.content.PaginationResponse} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_pagination_pb.PaginationResponse, 2));
};


/**
 * @param {?proto.io.codedrills.proto.content.PaginationResponse|undefined} value
 * @return {!proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse} returns this
*/
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse.prototype.setPaginationResponse = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse} returns this
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse.prototype.clearPaginationResponse = function() {
  return this.setPaginationResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.judge.master.GetProblemSubmissionsAdminResponse.prototype.hasPaginationResponse = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    submissionIdList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest}
 */
proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest;
  return proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest}
 */
proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setSubmissionIdList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubmissionIdList();
  if (f.length > 0) {
    writer.writePackedInt32(
      1,
      f
    );
  }
};


/**
 * repeated int32 submission_id = 1;
 * @return {!Array<number>}
 */
proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest.prototype.getSubmissionIdList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest} returns this
 */
proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest.prototype.setSubmissionIdList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest} returns this
 */
proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest.prototype.addSubmissionId = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest} returns this
 */
proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsRequest.prototype.clearSubmissionIdList = function() {
  return this.setSubmissionIdList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    submissionPreviewList: jspb.Message.toObjectList(msg.getSubmissionPreviewList(),
    io_codedrills_proto_content_preview_pb.SubmissionPreview.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse}
 */
proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse;
  return proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse}
 */
proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_preview_pb.SubmissionPreview;
      reader.readMessage(value,io_codedrills_proto_content_preview_pb.SubmissionPreview.deserializeBinaryFromReader);
      msg.addSubmissionPreview(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubmissionPreviewList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      io_codedrills_proto_content_preview_pb.SubmissionPreview.serializeBinaryToWriter
    );
  }
};


/**
 * repeated io.codedrills.proto.content.SubmissionPreview submission_preview = 1;
 * @return {!Array<!proto.io.codedrills.proto.content.SubmissionPreview>}
 */
proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse.prototype.getSubmissionPreviewList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.SubmissionPreview>} */ (
    jspb.Message.getRepeatedWrapperField(this, io_codedrills_proto_content_preview_pb.SubmissionPreview, 1));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.SubmissionPreview>} value
 * @return {!proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse} returns this
*/
proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse.prototype.setSubmissionPreviewList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.SubmissionPreview=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.SubmissionPreview}
 */
proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse.prototype.addSubmissionPreview = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.io.codedrills.proto.content.SubmissionPreview, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse} returns this
 */
proto.io.codedrills.proto.judge.master.GetSubmissionPreviewsByIdsResponse.prototype.clearSubmissionPreviewList = function() {
  return this.setSubmissionPreviewList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.judge.master.DeleteAnswersRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.DeleteAnswersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.DeleteAnswersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.DeleteAnswersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.DeleteAnswersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    testId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    candidateIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.DeleteAnswersRequest}
 */
proto.io.codedrills.proto.judge.master.DeleteAnswersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.DeleteAnswersRequest;
  return proto.io.codedrills.proto.judge.master.DeleteAnswersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.DeleteAnswersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.DeleteAnswersRequest}
 */
proto.io.codedrills.proto.judge.master.DeleteAnswersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addCandidateIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.DeleteAnswersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.DeleteAnswersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.DeleteAnswersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.DeleteAnswersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTestId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCandidateIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional int32 test_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.judge.master.DeleteAnswersRequest.prototype.getTestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.judge.master.DeleteAnswersRequest} returns this
 */
proto.io.codedrills.proto.judge.master.DeleteAnswersRequest.prototype.setTestId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated string candidate_ids = 2;
 * @return {!Array<string>}
 */
proto.io.codedrills.proto.judge.master.DeleteAnswersRequest.prototype.getCandidateIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.io.codedrills.proto.judge.master.DeleteAnswersRequest} returns this
 */
proto.io.codedrills.proto.judge.master.DeleteAnswersRequest.prototype.setCandidateIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.judge.master.DeleteAnswersRequest} returns this
 */
proto.io.codedrills.proto.judge.master.DeleteAnswersRequest.prototype.addCandidateIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.judge.master.DeleteAnswersRequest} returns this
 */
proto.io.codedrills.proto.judge.master.DeleteAnswersRequest.prototype.clearCandidateIdsList = function() {
  return this.setCandidateIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.DeleteAnswersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.DeleteAnswersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.DeleteAnswersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.DeleteAnswersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.DeleteAnswersResponse}
 */
proto.io.codedrills.proto.judge.master.DeleteAnswersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.DeleteAnswersResponse;
  return proto.io.codedrills.proto.judge.master.DeleteAnswersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.DeleteAnswersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.DeleteAnswersResponse}
 */
proto.io.codedrills.proto.judge.master.DeleteAnswersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.DeleteAnswersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.DeleteAnswersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.DeleteAnswersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.DeleteAnswersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.AllSubmissionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.AllSubmissionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.AllSubmissionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.AllSubmissionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.AllSubmissionsRequest}
 */
proto.io.codedrills.proto.judge.master.AllSubmissionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.AllSubmissionsRequest;
  return proto.io.codedrills.proto.judge.master.AllSubmissionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.AllSubmissionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.AllSubmissionsRequest}
 */
proto.io.codedrills.proto.judge.master.AllSubmissionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.AllSubmissionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.AllSubmissionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.AllSubmissionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.AllSubmissionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.judge.master.AllSubmissionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.judge.master.AllSubmissionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.judge.master.AllSubmissionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.judge.master.AllSubmissionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.AllSubmissionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    submissionsList: jspb.Message.toObjectList(msg.getSubmissionsList(),
    io_codedrills_proto_judge_judge_pb.Submission.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.judge.master.AllSubmissionsResponse}
 */
proto.io.codedrills.proto.judge.master.AllSubmissionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.judge.master.AllSubmissionsResponse;
  return proto.io.codedrills.proto.judge.master.AllSubmissionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.judge.master.AllSubmissionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.judge.master.AllSubmissionsResponse}
 */
proto.io.codedrills.proto.judge.master.AllSubmissionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_judge_judge_pb.Submission;
      reader.readMessage(value,io_codedrills_proto_judge_judge_pb.Submission.deserializeBinaryFromReader);
      msg.addSubmissions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.judge.master.AllSubmissionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.judge.master.AllSubmissionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.judge.master.AllSubmissionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.judge.master.AllSubmissionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubmissionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      io_codedrills_proto_judge_judge_pb.Submission.serializeBinaryToWriter
    );
  }
};


/**
 * repeated io.codedrills.proto.judge.Submission submissions = 1;
 * @return {!Array<!proto.io.codedrills.proto.judge.Submission>}
 */
proto.io.codedrills.proto.judge.master.AllSubmissionsResponse.prototype.getSubmissionsList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.judge.Submission>} */ (
    jspb.Message.getRepeatedWrapperField(this, io_codedrills_proto_judge_judge_pb.Submission, 1));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.judge.Submission>} value
 * @return {!proto.io.codedrills.proto.judge.master.AllSubmissionsResponse} returns this
*/
proto.io.codedrills.proto.judge.master.AllSubmissionsResponse.prototype.setSubmissionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.io.codedrills.proto.judge.Submission=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.judge.Submission}
 */
proto.io.codedrills.proto.judge.master.AllSubmissionsResponse.prototype.addSubmissions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.io.codedrills.proto.judge.Submission, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.judge.master.AllSubmissionsResponse} returns this
 */
proto.io.codedrills.proto.judge.master.AllSubmissionsResponse.prototype.clearSubmissionsList = function() {
  return this.setSubmissionsList([]);
};


goog.object.extend(exports, proto.io.codedrills.proto.judge.master);
